import {
  REQUEST_PAST_EXPERIENCES,
  RECEIVE_PAST_EXPERIENCES,
  SET_ACTIVE_PAST_EXPERIENCES,
  RECEIVE_PAST_EXPERIENCES_ERROR
} from '../constants/actionTypes';

import { sortBy } from 'lodash';

function sortpastExperiencesByID(pastExperiences) {
  if(pastExperiences.length < 1) {
    return pastExperiences;
  } else {
    return sortBy(pastExperiences, ['id']);
  }
}

const INITIAL_STATE = {
  pastExperiences: [],
  currentPastExperience: -1,
  hasFetched: false,
  loading: true,
  error: null,
};

function pastExperiencesReducer(state = INITIAL_STATE, action) {
  switch(action.type) {
    case REQUEST_PAST_EXPERIENCES: {
      return {
        ...state,
        error: null,
        loading: true
      };
    }
    case RECEIVE_PAST_EXPERIENCES: {
      return {
        ...state,
        pastExperiences: sortpastExperiencesByID(action.response),
        hasFetched: true,
        loading: false,
      };
    }
    case SET_ACTIVE_PAST_EXPERIENCES: {
      return {
        ...state,
        currentPastExperience: action.id,
      };
    }
    case RECEIVE_PAST_EXPERIENCES_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    }
    default:
      return state;
  }
}

export default pastExperiencesReducer;
